module.exports = __webpack_public_path__ + "assets/img/05_large.9097219d.png";